<template>
  <div>
    <div class="dataDetails" v-if="isShelves">
      <Left :detailsData="detailsData" />
      <center :detailsData="detailsData" />
      <Right
        :wenxian="wenxian"
        :detailsData="detailsData"
        :autherInfo="autherInfo"
        :timeData="timeData"
        :periodicalId="periodicalId"
        :periodicalInfo="periodicalInfo"
      />
    </div>
    <div class="dataDetails" v-else>
      <Shelves />
    </div>
  </div>
</template>

<script>
import Left from "../components/left";
import Center from "./components/center";
import Right from "./components/right";
import Shelves from "../components/shelves";

export default {
  name: "index",
  components: {
    Left,
    Center,
    Right,
    Shelves,
  },
  data() {
    return {
      isShelves: true,
      detailsData: {},
      wenxian: [],
      autherInfo: {},
      // autherList: {},
      timeData: {},
      periodicalId: {},
      periodicalInfo: {},
    };
  },
  created() {
    this.getDetails();
  },
  methods: {
    async getPublisherInfo() {
      let PublisherObj = {
        createUser: this.detailsData.data.createUser,
      };
      this.detailsData.data.companyId
        ? (PublisherObj["companyId"] = this.detailsData.data.companyId)
        : null;
      console.log(PublisherObj, "PublisherObj");
      const timeData = await this.$apis.recomendServe.PublisherInfo(
        PublisherObj
      );
      console.log(timeData, "timeData");
      this.timeData = timeData.data;
    },
    async getAuthor() {
      let userobj = {
        type: this.detailsData.data.userType,
      };
      if (this.detailsData.data.userType == 0) {
        userobj["userId"] = this.detailsData.data.createUser;
      } else {
        userobj["companyId"] = this.detailsData.data.companyId;
      }

      const res = await this.$apis.recomendServe.getAuthor(userobj);

      this.autherInfo = res.content;
    },

    async Getperiodical() {
      // 获取期刊信息
      let obj = {
        type: this.detailsData.data.userType,
        // periodicalId
        companyId: this.detailsData.data.periodicalId,
      };

      // 获取期刊信息与作者信息共用一个接口 getAuthor()方法
      // const res = await this.$apis.recomendServe.periodical(obj1);
      const res = await this.$apis.recomendServe.getAuthor(obj);

      this.periodicalInfo = res.content;
      // this.periodicalInfo = res.content.periodicalInfo;
    },
    async getperiodiID() {
      let obj = {
        periodicalId: this.detailsData.data.periodicalId,
      };
      console.log(obj, "getperiodiIDObj");
      const res = await this.$apis.recomendServe.periodiID(obj);
      this.periodiID = res.data;
      console.log(res);
    },
    async getwenxian() {
      const { data } = await this.$apis.recomendServe.getwenxian({
        businessId2: this.detailsData.data.businessId2,
        pageNo: 1,
        pageSize: 5,
      });
      try {
        this.wenxian = data.list;
        console.log(this.wenxian, "this.wenxian");
      } catch (e) {
        console.log(e);
      }
    },
    async getDetails() {
      let res = await this.$apis.recomendServe.getDetails({
        articleId: this.$router.history.current.query.id,
        articleType: this.$router.history.current.query.type,
      });
      if (res.resultCode === "200") {
        this.detailsData = res.data;
        document.title = this.$global.matchReg(this.detailsData.data.reportName)
        await this.getwenxian();
        if (this.detailsData.data.userType === 1) {
          await this.Getperiodical();
          await this.getperiodiID();
        } else {
          await this.getAuthor();
          await this.getPublisherInfo();
        }
      } else if (res.resultCode === "10401002" || res.resultCode === "10401001") {
        this.isShelves = false
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dataDetails {
  width: 1300px;
  display: flex;
}
</style>
